import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { GameViewController } from "./controllers/GameViewController";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { GameView } from "./views/GameView";
import { GameModel } from "./models/game/GameModel";
import { GameUIResourcesPackage } from "../preloader/resources/GameUIResourcesPackage";
import { CellViewFactory } from "./views/components/cells/CellViewFactory";
import { TriangleViewFactory } from "./views/components/triangles/TriangleViewFactory";
import { FigureViewFactory } from "./views/components/figures/FigureViewFactory";
import { FullscreenBackground } from "../common/components/FullscreenBackground";
import { PlayerModel } from "./models/player/PlayerModel";
import { Localization } from "../common/Localization";
import { AudioManager } from "../../audio/AudioManager";


@injectable()
export class GameScene extends Viewable<void> {
    public constructor(
        gameUIResourcesPackage: GameUIResourcesPackage,
        gameModel: GameModel,
        playerModel: PlayerModel,
        gameViewController: GameViewController,
        cellViewFactory: CellViewFactory,
        triangleViewFactory: TriangleViewFactory,
        figureViewFactory: FigureViewFactory,
        @inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler,
        fullscreenBackground: FullscreenBackground,
        localization: Localization,
        audioManager: AudioManager
    ) {
        super();
        const sceneCanBeClosed = new PromiseCompletionSource<void>();
        sceneCanBeClosed.result.then(() => {
            this.operationControls.complete();
        });
        this.view = new GameView(
            gameUIResourcesPackage,
            gameModel,
            playerModel,
            gameViewController,
            cellViewFactory,
            triangleViewFactory,
            figureViewFactory,
            canvasScaler,
            fullscreenBackground,
            localization,
            audioManager,
            sceneCanBeClosed
        );
    }
}